import { render } from "./Emails.vue?vue&type=template&id=796f8b6d"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"
script.render = render

export default script